import styled, { css } from 'styled-components';

import { layout } from 'src/components/base';

import ToggleIcon from '../../../icons/toggle-sidebar';
import { zindex } from 'src/ui/zindex';

const padding = layout.measurements.spacing050;
const menuWidth = layout.sidebarMenuWidth.desktop;

export const SidebarMenu = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  align-items: center;
  width: ${menuWidth.rem};
  background-color: ${p => p.theme.colors.base100};
  padding: ${padding} 0;
  z-index: ${zindex.menu.left};
`;

export const TopBar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  > * {
    margin-top: ${padding};
    margin-bottom: ${padding};
  }
`;

export const BottomBar = styled.div`
  position: relative;
  margin-top: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: ${padding};
  padding-top: ${padding};

  > * {
    margin-top: ${padding};
    margin-bottom: ${padding};
  }
`;

type MenuButtonProps = {
  active?: boolean;
  hoverEffect?: 'background' | 'color';
  hidden?: boolean;
};

export const MenuButton = styled.button<MenuButtonProps>(
  props => css`
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 20px;
    margin-left: auto;
    margin-right: auto;
    transition: background 200ms ease, color 200ms ease, visibility 0s ease 0s,
      opacity 200ms;
    background: transparent;
    color: ${props.theme.colors.base500};
    visibility: visible;
    opacity: 1;

    ${props.active &&
    props.hoverEffect === 'background' &&
    css`
      color: ${props.theme.colors.base0};
      background-color: ${props.theme.icons.callToActionHover};
    `}

    rect,
    path {
      fill: ${props.active ? props.theme.colors.base0 : 'currentColor'};
    }

    ${props.hidden &&
    css`
      visibility: hidden;
      opacity: 0;
      transition: visibility 0s ease 200ms, opacity 200ms;
    `}

    &:hover,
    &.focus-visible {
      color: ${props.active ? 'inherit' : props.theme.icons.callToActionHover};
    }
  `
);

MenuButton.defaultProps = {
  hoverEffect: 'background',
};

export const Divider = styled.div`
  pointer-events: none;
  background: ${p => p.theme.lines.primary};
  height: 1px;
  width: 75%;
`;

type ToggleSidebarIconProps = {
  open: boolean;
};
export const ToggleSidebarIcon = styled(ToggleIcon)<ToggleSidebarIconProps>`
  color: ${p => p.theme.colors.base300};
  &:hover,
  &.focus-visible {
    color: ${p => p.theme.icons.callToActionHover};
  }
  transition: transform 200ms ease;
  transform: ${p => (p.open ? 'rotate(180deg)' : 'none')};
`;
